<div *ngIf="!newInref && !editInref && (isSupportAdmin || isSuperAdmin)">
  <h1
    style="
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
        Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
      font-weight: 500;
      color: #105481;
      margin-bottom: 0.5rem;
      font-size: 2.5rem;
      font-weight: 500;
      line-height: 1.2;
    "
    id="inrefHeader"
  >
    InfRef Administration
  </h1>

  <div class="left" *ngIf="isSupportAdmin || isSuperAdmin">
    <button
      pButton
      class="add-button left"
      (click)="onNyInref()"
      id="newInrefbutton"
    >
      <mat-icon>add</mat-icon>Ny InfRef
    </button>
  </div>
  <div>
    <p-table
      #dt1
      [value]="administration"
      id="administrationtb_id"
      [rows]="rowsPerPage"
      [paginator]="false"
      [rowHover]="true"
      dataKey="id"
      selectionMode="single"
      (onRowSelect)="onRowSelect($event)"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [sortField]="sortField"
      [sortOrder]="sortOrder"
      stateStorage="session"
      [stateKey]="tableName"
      [showFirstLastIcon]="false"
      [customSort]="true"
      (sortFunction)="customSort($event)"
    >
      <ng-template pTemplate="header">
        <tr>
          <th hidden="true" id="adminId">id</th>
          <th style="width: 30%" pSortableColumn="infRefName" id="InrefHeaf">
            InfRef<p-sortIcon field="infRefName"></p-sortIcon>
          </th>
          <th style="width: 25%" pSortableColumn="serviceType" id="typeHead">
            Type<p-sortIcon field="serviceType"></p-sortIcon>
          </th>
          <th style="width: 25%" pSortableColumn="routingType" id="ruteTypeHead">
            Rute Type<p-sortIcon field="routingType"></p-sortIcon>
          </th>
          <th style="width: 25%" pSortableColumn="flagString" id="isActivatedHead">
            Automatisk aktivering<p-sortIcon field="flagString"></p-sortIcon>
          </th>
        </tr>
        <tr>
          <th id="nameFilterHead">
            <input
              style="width: 100%"
              pInputText
              type="text"
              #textInput1
              id="nameFilter"
              (input)="inputChange(textInput1.value, 'infRefName')"
              [value]="$any(dt1.filters['infRefName'])?.value"
              class="p-column-filter"
            />
          </th>
          <th id="serviceTypeFilterHead">
            <input
              style="width: 100%"
              pInputText
              type="text"
              #textInput2
              id="serviceTypeFilter"
              (input)="inputChange(textInput2.value, 'serviceType')"
              [value]="$any(dt1.filters['serviceType'])?.value"
              class="p-column-filter"
            />
          </th>
          <th id="routeTypeFilterHead">
            <input
              style="width: 100%"
              pInputText
              type="text"
              #textInput3
              id="routeTypeFilter"
              (input)="inputChange(textInput3.value, 'routingType')"
              [value]="$any(dt1.filters['routingType'])?.value"
              class="p-column-filter"
            />
          </th>
          <th id="flagFilterHead">
            <input
              style="width: 100%"
              pInputText
              type="text"
              #textInput4
              id="flagFilter"
              (input)="inputChange(textInput4.value, 'flagString')"
              [value]="$any(dt1.filters['flagString'])?.value"
              class="p-column-filter"
            />
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-prod>
        <tr [pSelectableRow]="prod">
          <td hidden="true" id="{{ prod.infRefId }}">{{ prod?.infRefId }}</td>
          <td id="{{ prod.infRefName }}">{{ prod?.infRefName }}</td>
          <td  id="{{  prod.serviceType }}"> {{ getServiceTypeText(prod.serviceType)}}</td>
          <td id="{{ prod.routingType }}">{{ prod?.routingType }}</td>
          <td id="{{ prod.flagString }}">{{ prod?.flagString }}</td>
        </tr>
      </ng-template>
    </p-table>
    <br />
  </div>
</div>

<app-edit-inref
  (cancelClickEvent)="editCancel()"
  [isSuperAdmin]="isSuperAdmin"
  [isSupportAdmin]="isSupportAdmin"
  (submitClickedEvent)="editSubmit()"
  [newInref]="newInref"
  *ngIf="newInref || editInref"
  [infRef]="infRef"
></app-edit-inref>

<p-confirmDialog
  [ngStyle]="{ backgroundColor: '$dialogHeaderBg: #ffffff;' }"
  [transitionOptions]="'400ms cubic-bezier(0.25, 0.8, 0.25, 1)'"
  header="Confirmation"
  acceptIcon=""
  rejectIcon=""
>
</p-confirmDialog>
<ngb-pagination #paginationAdmin *ngIf="showPagination && (!newInref && !editInref && (isSupportAdmin || isSuperAdmin))" aria-label="pagination"
  class="d-flex justify-content-center" [collectionSize]="totalRecords" [(page)]="currentPage" [pageSize]="rowsPerPage"
  [maxSize]="5" [rotate]="true" size="lg" [boundaryLinks]="false" (pageChange)="onPageChange($event)">
</ngb-pagination>
